<template>
  <div :class="['row', addContainerClasses]">
    <div class="col-12 col-md-4 col-xl-3 font-weight-bold" v-html="title" />
    <div class="col-12 col-md-8 col-xl-7">
      <div class="row">
        <div
        v-for="(item, index) in items"
        :key="index"
        class="col-12 col-md-6">

          <button type="button"
          :class="['btn btn-sm btn-outline-filter w-100 h-100', filterUiState('goal', item.value)]"
          v-on:click="selectValue(item.value)">{{ item.title }}</button>

        </div>
        
      </div>
      
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import { trackCallstack } from '../../../helper/tracker'

export default {
  name: 'StoCscFilterSectionGoal',
  props: {
    addContainerClasses: String
  },
  data: function () {
    return {
      title: 'Ziel / Wunsch',
      items: [
        { title: 'Effizient Energie sparen', value: 'goal-1' },
        { title: 'Technisch effizient und mit ökologischen Vorteilen', value: 'goal-2' },
        { title: 'Sanierung alter Fassaden ohne Dämmung', value: 'goal-3' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      filterUiState: 'filter/uiState',
      filterState: 'filter/state'
    })
  },
  methods: {
    selectValue: function (value) {
      let title = ''
      const result = this.items.filter(item => item.value === value)
      if (result.length > 0) title = result[0].title

      const uiState = this.filterUiState('goal', value)

      this.$gtm.trackEvent({
        event: 'filter',
        category: this.title,
        action: uiState === 'pending' ? 'hinzufügen' : (uiState === 'active' ? 'reaktivieren' : 'aktivieren'),
        label: title,
        value: value
      })

      this.$store.dispatch('filter/setValue', {
        name: 'goal',
        title: this.title + ' ' + title,
        value: value
      }).then(() => trackCallstack(this.$gtm, this.filterState._callstack))
    }
  }
}

</script>
